import {createRouter, createWebHistory, RouterView} from 'vue-router'
import HomePage from "@/pages/home-page.vue";
import translation from "@/core/helpers/translations.js";
import StorePage from "@/pages/store-page.vue";
import LoginPage from "@/pages/login-page.vue";
import RegisterPage from "@/pages/register-page.vue";
import PolicyPage from "@/pages/policy-page.vue";
import TermsPage from "@/pages/terms-page.vue";
import ResetPage from "@/pages/reset-page.vue";
import ContactPage from "@/pages/contact-page.vue";
import AboutPage from "@/pages/about-page.vue";
import FaqPage from "@/pages/faq-page.vue";
import NewPasswordPage from "@/pages/new-password-page.vue";
import {checkAuth} from "@/core/guards/notAuthGuard.js";
import ProfilePage from "@/pages/profile-page.vue";
import ProfileDashboard from "@/components/profile/profile-dashboard.vue";
import ProfileOrders from "@/components/profile/profile-orders.vue";
import ProfileWishlist from "@/components/profile/profile-wishlist.vue";
import ProfileCart from "@/components/profile/profile-cart.vue";
import ProfileDetails from "@/components/profile/profile-details.vue";
import DescriptionPage from "@/pages/description-page.vue";

const routes = [
  {
    path: '/:locale?',
    component: RouterView,
    beforeEnter: translation.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: HomePage,
        meta: {
          title: "Home"
        }
      },
      {
        path: 'activate-user',
        name: 'activate-user',
        component: HomePage,
        meta: {
          title: 'Home'
        }
      },
      {
        name: 'payment',
        path: 'payment',
        component: HomePage,
        meta: {
          title: 'Home'
        }
      },
      {
        path: 'store',
        name: 'store',
        component: StorePage,
        meta: {
          title: 'Store'
        }
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          title: 'Login'
        }
      },
      {
        path: 'register',
        name: 'register',
        component: RegisterPage,
        meta: {
          title: 'Register'
        }
      },
      {
        path: 'reset',
        name: 'reset',
        component: ResetPage,
        meta: {
          title: 'Reset'
        }
      },
      {
        path: 'reset-password',
        name: 'new-password',
        component: NewPasswordPage,
        meta: {
          title: 'New Password'
        }
      },
      {
        path: 'terms-of-use',
        name: 'terms',
        component: TermsPage,
        meta: {
          title: 'Terms of Use'
        }
      },
      {
        path: 'privacy-policy',
        name: 'policy',
        component: PolicyPage,
        meta: {
          title: 'Privacy Policy'
        }
      },
      {
        path: 'product-description',
        name: 'description',
        component: DescriptionPage,
        meta: {
          title: 'Product Description'
        }
      },
      {
        path: 'contact',
        name: 'contact',
        component: ContactPage,
        meta: {
          title: 'Contact'
        }
      },
      {
        path: 'about',
        name: 'about',
        component: AboutPage,
        meta: {
          title: 'About'
        }
      },
      {
        path: 'faq',
        name: 'faq',
        component: FaqPage,
        meta: {
          title: 'FAQ'
        }
      },
      {
        path: 'profile',
        name: 'profile',
        component: ProfilePage,
        beforeEnter: checkAuth,
        meta: {
          title: "Profile"
        },
        children: [
          {
            path: 'dashboard',
            name: 'profile-dashboard',
            component: ProfileDashboard
          },
          {
            path: 'orders',
            name: 'profile-orders',
            component: ProfileOrders
          },
          {
            path: 'wishlist',
            name: 'profile-wishlist',
            component: ProfileWishlist
          },
          {
            path: 'cart',
            name: 'profile-cart',
            component: ProfileCart
          },
          {
            path: 'details',
            name: 'profile-details',
            component: ProfileDetails
          }
        ]
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title ? 'New Gifts Store | ' + to.meta?.title : 'New Gifts Store'
})

export default router
